import { FC, ReactNode, memo, useEffect, useState } from "react";
import { DisplayKey } from "@/models/auth";
import { useAuthUser } from "@/hooks/useAuthUser";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthChecker } from "@/hooks/useAuthChecker";
import { Title } from "@/common/CommonConstants";

type Props = {
  component: ReactNode;
  name: DisplayKey;
  title: string;
};

export const RouteAuthGuard: FC<Props> = memo((props) => {
  const [display, setDisplay] = useState<Boolean>(false);
  const { name, component, title } = props;
  const { user, isLoading, location, triggerHock } = useAuthUser();
  const { authChecker } = useAuthChecker();
  const toLocation = useLocation();
  const fromLocation = location;

  useEffect(() => {
    triggerHock(toLocation.pathname, fromLocation);
  }, [fromLocation, toLocation.pathname, triggerHock]);

  useEffect(() => {
    document.title = title + "｜" + Title;
  }, [title]);

  // isLoadingの更新が反映されない対策として「display」との2段構えにする
  useEffect(() => {
    if (!isLoading) {
      setDisplay(true);
    }
  }, [isLoading]);

  // タクモニログイン済みか否かを確認している間は、ローディング画面を表示
  if (isLoading || !display) {
    return <div>通信中...</div>;
  }
  
  // 有効なセッションでログイン画面に来たときはダッシュボードに遷移する
  if (location === "/login") {
    if (user?.auth && authChecker(name)) {
      return <Navigate to={"/dashboard"} replace={true} />;
    }
    return <>{component}</>;
  }

  // 認証に成功したらその画面に、失敗したらログイン画面に遷移させる
  if (user?.auth && authChecker(name)) {
    return <>{component}</>;
  }

  // ログイン画面に遷移する際、現在のパスをredirectパラメータとして付与
  const redirectPath = `/login?redirect=${encodeURIComponent(toLocation.pathname + toLocation.search)}`;
  return <Navigate to={redirectPath} replace={true} />;
});
